export default {
    getHeaderFieldsEprofileAllergia: state => state.headerFieldsEprofileAllergia,
    getFormActionsEprofileAllergia: state => state.formActionsEprofileAllergia,
    getActionsEprofileAllergia: state => state.actionsEprofileAllergia,
    getRowActionsEprofileAllergia: state => state.rowActionsEprofileAllergia,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileAllergia: state => state.formIsOpen,
    isGridOpenEprofileAllergia: state => state.gridIsOpen
}
